import { ref } from '@vue/composition-api'
import EmailService from '@/services/modules/EmailService'

const loginWindow = ref(null)
const loading = ref(false)

async function loginComMicrosoft() {
  try {
    loading.value = true
    const { url } = await EmailService.getSignInUrl()

    // Salva URL atual para retorno caso o popup seja bloqueado e o OAuth ocorra na aba principal
    localStorage.setItem('microsoft-auth-return-url', window.location.href)

    loginWindow.value = window.open(url, '_blank', 'width=600,height=700')

    // Se o popup foi bloqueado (window.open retorna null), redireciona a aba principal
    if (!loginWindow.value) {
      window.location.href = url
    }
  } finally {
    loading.value = false
  }
}

export function useMicrosoftLogin() {
  return {
    loginComMicrosoft,
    loading,
  }
}
